import moment from "moment";
import { SampleSendType } from "utils/constant";

const RECEIVED_FIELDS = [
  "sample_sad_received_date",
  "sample_dbs_received_date",
  "sample_wb_received_date",
];

// Tanggal terima sampel paling akhir yang terisi ("YYYY-MM-DD") atau null.
export const latestReceivedDate = (values = {}) => {
  const dates = RECEIVED_FIELDS.map((field) => values?.[field]).filter(Boolean);
  if (dates.length === 0) return null;

  return dates.reduce((latest, date) =>
    moment(date, "YYYY-MM-DD").isAfter(moment(latest, "YYYY-MM-DD"), "day")
      ? date
      : latest
  );
};

// Jenis sampel dianggap dikirim hanya bila tercantum di sample_send_type.
// Kolom tanggal kirim tidak dipakai sebagai penanda karena tanggal kirim hanya
// terisi untuk jenis yang dicentang (jenis lain null).
export const hasSentType = (row = {}, type) => {
  const types = Array.isArray(row?.sample_send_type) ? row.sample_send_type : [];
  return types.includes(type);
};

const STEP1_FIELDS = {
  [SampleSendType.SAD]: ["sample_sad_received_date", "sample_sad_condition"],
  [SampleSendType.DBS]: ["sample_dbs_received_date", "sample_dbs_condition"],
  [SampleSendType.WB]: ["sample_wb_received_date", "sample_wb_condition"],
};

// Step 1 selesai bila tanggal terima dan kondisi terisi untuk SETIAP jenis
// sampel yang dikirim. Umpan balik tidak termasuk syarat.
export const isStep1Complete = (row = {}) => {
  const types = Array.isArray(row?.sample_send_type)
    ? row.sample_send_type.filter(Boolean)
    : [];
  // Tanpa jenis sampel = data lama (sebelum migrasi sample_send_type): waktu itu
  // SAD wajib dikirim, jadi penilaian memakai aturan SAD.
  if (types.length === 0) {
    return Boolean(row?.sample_sad_received_date && row?.sample_sad_condition);
  }
  return types.every((type) => {
    const fields = STEP1_FIELDS[type];
    return Array.isArray(fields) && fields.every((f) => Boolean(row?.[f]));
  });
};

const SENT_TO_TIER5 = "Ya";

// State kolom aksi: Step 1 + Step 2 selesai -> status saja; Step 1 selesai
// saja -> masih bisa diedit; belum selesai -> hanya tombol Edit.
export const actionState = (row = {}) => {
  const step1Done = isStep1Complete(row);
  const step2Done = row?.is_send_to_lab_tier_5 === SENT_TO_TIER5;
  if (step1Done && step2Done) return "checked";
  if (step1Done) return "edit-checked";
  return "edit";
};

// Tanggal selesai PCR tidak boleh lebih awal dari tanggal terima terakhir.
// Kosong tetap opsional (perilaku lama).
export const pcrDateError = (values = {}) => {
  const pcrDate = values?.pcr_finish_checking_date;
  if (!pcrDate) return null;

  const receivedDate = latestReceivedDate(values);
  if (!receivedDate) return null;

  return moment(pcrDate, "YYYY-MM-DD").isBefore(
    moment(receivedDate, "YYYY-MM-DD"),
    "day"
  )
    ? "Tanggal selesai pemeriksaan PCR tidak boleh kurang dari tanggal sampel diterima"
    : null;
};
